// extracted by mini-css-extract-plugin
export default {"language__select":"UiSelect_language__select__syRWx"};